import {
  Form,
  Image,
  Button,
  Space,
  Row,
  Col,
  Typography,
  Flex,
  Divider,
} from "antd";
import { useShareDispatch, useShareSelector, actionsApi } from "../../shared";
import { NavLink, useNavigate } from "react-router-dom";
import { CitiesInput } from "../../components";

const { Title, Text } = Typography;

const ForgotPassword = () => {
  const [form] = Form.useForm();
  const appDispatcher = useShareDispatch();
  const navigate = useNavigate();
  const { loading, otpToken, requestState } = useShareSelector(
    (state) => state?.login,
  );

  const forgotpass = () => {
    if (requestState === "request") {
      appDispatcher(actionsApi?.forgotPassword(form.getFieldsValue(["email"])));
    }
    if (requestState === "otp") {
      appDispatcher(actionsApi?.otpVerify(form.getFieldsValue(["otp"])));
    }
    if (requestState === "reset") {
      const data = form.getFieldsValue(["password", "confirmationPassword"]);
      appDispatcher(
        actionsApi?.resetPassword({
          data: { token: otpToken, ...data },
          navigate,
        }),
      );
    }
  };

  return (
    <div className="login-form-cover">
      <div className="center">
        <Row className="login-form border-grey">
          <Col md={11} sm={24} xs={24}>
            <Space
              direction="vertical"
              className="py-5 my-2 px-4 width-100"
              size={15}
            >
              <div className="justify-center">
                <Image
                  src={"./assets/images/logo.webp"}
                  alt="Hair Plus International"
                  preview={false}
                />
              </div>
              <Title level={5} className="my-0 text-center repla-color">
                {requestState === "request" && "Forgot Password"}
                {requestState === "otp" && "Enter OTP"}
                {requestState === "reset" && "Reset Password"}
              </Title>
              <Form
                form={form}
                layout="vertical"
                initialValues={{
                  remember: true,
                }}
                onFinish={forgotpass}
                style={{ width: "100%" }}
              >
                <Row gutter={[0, 4]}>
                  {requestState === "request" && (
                    <Col span={24} className="border">
                      <CitiesInput
                        name="email"
                        label="Email"
                        required
                        message="please enter email"
                        size="large"
                        placeholder="user@hprwp.com"
                        value={form.getFieldValue("email") || ""}
                      />
                    </Col>
                  )}
                  {requestState === "otp" && (
                    <Col span={24} className="border">
                      <CitiesInput
                        oTp
                        name="otp"
                        label="OTP"
                        size="large"
                        required
                        message="please enter otp"
                        value={form.getFieldValue("otp") || ""}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />
                    </Col>
                  )}
                  {requestState === "reset" && (
                    <>
                      <Col span={24}>
                        <CitiesInput
                          label="New Password"
                          type="password"
                          name="password"
                          size="large"
                          required
                          message={() => {}}
                          value={form.getFieldValue("password") || ""}
                          validator={({ getFieldValue }) => ({
                            validator: (_, value) => {
                              const reg =
                                /^(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*\d).{8,}$/;
                              if (!reg.test(value)) {
                                return Promise.reject(
                                  new Error(
                                    "Password should contain at least 8 characters, one uppercase letter, one number, one special character",
                                  ),
                                );
                              } else {
                                return Promise.resolve();
                              }
                            },
                          })}
                        />
                      </Col>
                      <Col span={24}>
                        <CitiesInput
                          label="Confirm Password"
                          type="password"
                          name="confirmationPassword"
                          dependencies={["password"]}
                          size="large"
                          required
                          message="Please enter confirm password"
                          value={
                            form.getFieldValue("confirmationPassword") || ""
                          }
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  !value ||
                                  getFieldValue("password") === value
                                ) {
                                  return Promise.resolve();
                                }
                                return Promise.reject(
                                  new Error(
                                    "The password that you entered do not match!",
                                  ),
                                );
                              },
                            }),
                          ]}
                          validator={({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value ||
                                getFieldValue("password") === value
                              ) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error(
                                  "The password that you entered do not match!",
                                ),
                              );
                            },
                          })}
                        />
                      </Col>
                    </>
                  )}
                  <Col span={24}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      loading={loading}
                      size="large"
                      block
                    >
                      {requestState === "request" && "Request for OTP"}
                      {requestState === "otp" && "Verify OTP"}
                      {requestState === "reset" && "Reset Password"}
                    </Button>
                  </Col>
                </Row>
              </Form>
              {requestState === "request" && (
                <>
                  <div>
                    <Divider
                      style={{ borderColor: "gray" }}
                      className="text-gray mt-4"
                    >
                      OR
                    </Divider>
                  </div>
                  <Space
                    gap={10}
                    align="center"
                    className="mt-3 justify-center"
                  >
                    <Text className="text-gray">
                      <NavLink to={"/login"} className="px-2 fw-400">
                        Sign In
                      </NavLink>
                    </Text>
                  </Space>
                </>
              )}
            </Space>
          </Col>
          <Col
            md={13}
            sm={0}
            xs={0}
            className="light-grey-bg flex-col-align-end"
            style={{ backgroundImage: "url(/assets/images/login-screen.png)" }}
          >
            <Title level={5} className="text-center light-grey-text">
              Version 1.1.6 Beta Release
            </Title>
          </Col>
        </Row>
      </div>
      <div className="center">
        <Text strong className="my-0 py-2 text-center text-white">
          © 2022 - {new Date().getFullYear()}. All rights reserved by{" "}
          <a
            href="https://replatechnologies.com/"
            rel="noreferrer"
            target="_blank"
          >
            Repla Technologies
          </a>
        </Text>
      </div>
    </div>
  );
};
export { ForgotPassword };
